<div class="part-dash-body">
    <div class="part-dash-welcome-title">{{welcomeTitle}}, {{appData.authData.userName}}</div>

    <div class="flex-row">
        <!-- Left block -->
        <div class="filler">
            <!-- Filter -->
            <div class="flex-row">
                <!-- Store -->
                <div>
                    <div class="flex-row">
                        <div class="part-dash-field-label">Store:</div>
                        <div>
                            <p-dropdown [options]="locations"
                                        [(ngModel)]="selectedLocationId"
                                        [optionLabel]="'Name'"
                                        [optionValue]="'Id'"
                                        (onChange)="onFilterChange()">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="flex-row" style="margin-top: 10px">
                        <div class="part-dash-label">Store status:</div>
                        <div *ngIf="partner.IsClosed" class="part-dash-status-closed">Closed</div>
                        <div *ngIf="!partner.IsClosed" class="part-dash-status-open">Open</div>
                    </div>
                </div>
                <!-- Period -->
                <div style="margin-left: 60px">
                    <div class="flex-row">
                        <div class="part-dash-field-label">Period:</div>
                        <div>
                            <p-dropdown [options]="periods"
                                        [(ngModel)]="selectedPeriodId"
                                        [optionLabel]="'Name'"
                                        [optionValue]="'Id'"
                                        (onChange)="onFilterChange()">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="flex-row" style="margin-top: 10px">
                        <div class="part-dash-label">Store rating: {{partner.Rating}}</div>
                    </div>
                </div>
            </div>

            <div class="part-dash-block-title" style="margin: 28px 0 11px 0">Sales Analytics</div>

            <p-tabMenu [model]="menuItems"
                       [activeItem]="activeItem"
                       (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>

            <div style="height: 14px"></div>

            <div *ngIf="activeItem.id===partnerDashboardTab.SalesTotal">
                <!-- salesChartData is empty -->
                <div *ngIf="salesDataState===1" class="part-dash-sales-empty-block">
                    <div class="part-dash-sales-empty-row">
                        <img style="width: 100px" src="{{adminUrl}}XpressApp/assets/images/partner/dashboard/sales-empty.png" />
                    </div>
                    <div class="part-dash-sales-empty-row-text">Your dashboard is empty.</div>
                    <div class="part-dash-sales-empty-row-text">Start by adding products, customers, or orders</div>
                    <div class="part-dash-sales-empty-row-text">to see your business metrics and insights in one place!</div>
                </div>

                <!-- salesChartData is not empty -->
                <div *ngIf="salesDataState===2">
                    <!-- Images block -->
                    <div class="flex-row" style="margin-bottom: 14px">
                        <div class="filler part-dash-sales-img-block"
                             style="background-image: url({{adminUrl}}XpressApp/assets/images/partner/dashboard/sales-background1.png)">
                            <div class="part-dash-sales-img-value">₱1,000,000.00</div>
                            <div class="part-dash-sales-img-percent">+ 25%</div>
                        </div>

                        <div style="width: 20px"></div>

                        <div class="filler part-dash-sales-img-block"
                             style="background-image: url({{adminUrl}}XpressApp/assets/images/partner/dashboard/sales-background2.png)">
                            <div class="part-dash-sales-img-value">₱2,000,000.00</div>
                            <div class="part-dash-sales-img-percent">+ 25%</div>
                        </div>
                    </div>

                    <!-- Chart -->
                    <div class="part-dash-sales-chart-block">
                        <p-chart [type]="'line'"
                                 [data]="salesChartData"
                                 [width]="'540px'"
                                 [height]="'374px'"
                                 [options]="salesChartOptions"></p-chart>
                    </div>
                </div>
            </div>

            <div *ngIf="activeItem.id===partnerDashboardTab.OrderVolume">
                TODO: OrderVolume
            </div>

            <div *ngIf="activeItem.id===partnerDashboardTab.TicketSize">
                TODO: TicketSize
            </div>
        </div>
        <!-- Right block -->
        <div class="filler" style="margin-left: 30px; min-width: 240px">
            <!-- Location filter -->
            <div class="part-dash-field-label">Location</div>
            <div style="margin-top: 8px">
                <p-dropdown [options]="locations"
                            [(ngModel)]="selectedLocationId"
                            [optionLabel]="'Name'"
                            [optionValue]="'Id'"
                            [style]="{width:'100%'}"
                            (onChange)="onFilterChange()">
                </p-dropdown>
            </div>

            <!-- Rating block -->
            <div class="part-dash-rating-block">
                <div class="flex-row">
                    <div>
                        <div class="part-dash-rating-title">Store Rating</div>
                        <div>
                            <p-rating [ngModel]="partner.Rating | number: '1.0-0'" [readonly]="true" [stars]="5" [cancel]="false"></p-rating>
                        </div>
                        <div class="part-dash-rating-reviews">{{partner.RatingsTotalCount}} reviews</div>
                    </div>
                    <div class="filler"></div>
                    <div class="part-dash-rating-value">{{partner.Rating}}</div>
                    <div class="filler"></div>
                </div>
            </div>

            <!-- Inbox block -->
            <div class="part-dash-block-title" style="margin: 28px 0 10px 0">Inbox</div>
            <div class="part-dash-inbox-block">
            </div>
        </div>
    </div>
</div>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 30vh; left: 60vw"></spinner>

<p-toast position="top-right"></p-toast>
